var auth = require('./auth');
import constants from '../config/constants';

var baseService = {};

baseService.fetchedData = {
                            categories: [],
                            municipalities: [],
                            cities: [],
                            users: [],
                            decisionTypes: [],
                            industries: []
                          };
baseService.fetchInProgress = false;

var listeners = [];

function userChanged(user) {
  if (user && user != null) {
    updateData();
  }
}

function updateData() {
  baseService.refreshAllData().catch(error => {
    console.log("Failed to fetch data. retrying (1)...");
    baseService.refreshAllData().catch(error => {
      console.log("Failed to fetch data. retrying (2)...");
      baseService.refreshAllData().catch(error => {
        console.log("Failed to fetch data. FAIL!");
      });
    });
  });
}


baseService.init = function() {
  auth.addListener(userChanged);
  if (auth.currentUser && auth.currentUser != null) {
    updateData();
  }
}

baseService.addListener = function(listener) {
  listeners.push(listener);
}

baseService.addCategory = function(category) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/categories', {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(category)
      }).then(response => {
        response.json().then(json => {
          baseService.refreshAllData().then(result => {
            resolve();
          });
        });
      });
    });
  });
}

baseService.addIndustry = function(industry) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      console.log('creating', industry)
      fetch(constants.apiUrl + '/industries', {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(industry)
      }).then(response => {
        response.json().then(json => {
          baseService.refreshAllData().then(result => {
            resolve();
          });
        });
      }).catch(error => {
        console.log(error)
      });
    });
  });
}

baseService.editCategory = function(category) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/categories', {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        method: 'PUT',
        body: JSON.stringify(category)
      }).then(response => {
        response.json().then(json => {
          baseService.refreshAllData().then(result => {
            resolve();
          });
        });
      });
    });
  });
}

baseService.editIndustry = function(industry) {
  return new Promise((resolve, reject) => {
    auth.getToken().then(token => {
      fetch(constants.apiUrl + '/industries', {
        headers: {
          'x-alueluettelo-auth': token,
          'Content-Type': 'application/json'
        },
        method: 'PUT',
        body: JSON.stringify(industry)
      }).then(response => {
        response.json().then(json => {
          baseService.refreshAllData().then(result => {
            resolve()
          })
        })
      })
    })
  })
}

baseService.refreshAllData = function() {
    return new Promise((resolve, reject) => {
      if (baseService.fetchInProgress || (auth.currentUser() == null)) {
        reject(null);
      } else {
        baseService.fetchInProgress = true;

        auth.getToken().then(token => {
          fetch(constants.apiUrl + '/admindata', {
            headers: {
              'x-alueluettelo-auth': token
            }
          }).then(response => {
            response.json().then(json => {
              baseService.fetchedData = json;
              baseService.fetchInProgress = false;

              for (var listenerIdx in listeners) {
                if (typeof(listeners[listenerIdx]) === 'function') {
                  listeners[listenerIdx](json);
                }
              }

              resolve(json);
            });
          });
      });
    }
  });
}

module.exports = baseService;



// WEBPACK FOOTER //
// ./src/service/baseservice.js